module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('q-layout', {
    attrs: {
      "id": "app"
    }
  }, [_c('NavView', {
    attrs: {
      "selectedTab": _vm.selectedTab,
      "hasBookmark": _vm.bookmarked.length > 0
    },
    on: {
      "changeTab": _vm.onChangeTab,
      "toggleDrawer": _vm.toggleDrawer
    },
    slot: "header"
  }), _vm._v(" "), _c('router-view', {
    staticClass: "desktop-only",
    attrs: {
      "name": "header"
    },
    slot: "navigation"
  }), _vm._v(" "), _c('router-view', {
    ref: "defaultView",
    staticClass: "auto",
    attrs: {
      "selectedTab": _vm.selectedTab,
      "hovered": _vm.hovered
    },
    on: {
      "hover": _vm.onHover,
      "focus": _vm.onFocus
    }
  }), _vm._v(" "), _c('router-view', {
    attrs: {
      "name": "aside",
      "selectedTab": _vm.selectedTab,
      "hovered": _vm.hovered
    },
    on: {
      "hover": _vm.onHover,
      "bookmark": _vm.onBookmark,
      "focus": _vm.onFocus,
      "toggleDrawer": _vm.toggleDrawer
    }
  }), _vm._v(" "), _c('FilterViewMobile', {
    ref: "drawer",
    staticClass: "mobile-only"
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-46debf29", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-46debf29!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/App.vue
// module id = 851
// module chunks = 0